import React from "react";
// import { SelectField } from 'redux-form-material-ui'
// import { SelectField } from 'redux-form-material-ui'
import Immutable from "immutable";

import customStyles from "./DynamicFilter.cssmodule.scss";
import IconDelete from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import typeCast from "mout/string/typecast";

// import SelectField from '@material-ui/core/Select';
import Select from "components/UI/Form/Select";
// import MenuItem from '@material-ui/core/MenuItem';

import { capitalize } from "helpers/stringUtils";
import { formatDate } from "helpers/stringUtils";

// import areIntlLocalesSupported from 'intl-locales-supported';

// let DateTimeFormat;

// if (areIntlLocalesSupported(['fr'])) {
// DateTimeFormat = global.Intl.DateTimeFormat;
// } else {
// const IntlPolyfill = require('react-intl');
// DateTimeFormat = IntlPolyfill.DateTimeFormat;
// require('react-intl/locale-data/fr');
// }

export default class DynamicFilterPastPresent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valueYear: undefined,
      valueMonth: undefined,
    };
  }

  componentDidMount() {
    if (this.props.$$filter.get('filter_value'))
    {
    const v = this.props.$$filter.get('filter_value').split('-');
    this.setState({ valueYear: parseInt(v[0], 10), valueMonth: parseInt(v[1], 10) });
    }
    // this.setState({ value: "" });
  }

  handleChangeYear(kind, target) {
    this.setState({ valueYear: target.value }, this.propagateFilterChanges);
  }
  handleChangeMonth(kind, target) {
    // console.log('new month', val)
    this.setState({ valueMonth: target.value }, this.propagateFilterChanges);
  }
  onClearFilter = (event) => {
    this.setState(
      { valueYear: undefined, valueMonth: undefined },
      this.propagateFilterChanges
    );
  };
  propagateFilterChanges() {
    const { valueYear, valueMonth } = this.state;
    if (
      valueYear === "" ||
      valueMonth === "" ||
      (valueYear !== null && valueMonth === null) ||
      (valueMonth !== null && valueYear === null)
    )
      return;
    const {
      // $$filter,
      onChange,
      filterId,
    } = this.props;
    const valStr = valueYear === undefined && valueMonth === undefined ? '@reset@' : valueYear + "-" + (valueMonth + 1);
    onChange(filterId, valStr);
  }
  render() {
    const { $$filter } = this.props;

    const { valueMonth, valueYear } = this.state;

    let months = [];

    let j, d, l;
    // const tzLong = { month: 'long' };
    for (j = 0; j < 12; j++) {
      d = new Date(2010, j, 1);
      // l =  capitalize(new Intl.DateTimeFormat('fr', tzLong).format(d));
      l = capitalize(formatDate(d / 1000, "mmmm"));
      months.push({ value: j, label: l });
    }
    let years = [];
    $$filter.get("filter_years").map((year, yk) => {
      years.push({ value: typeCast(year), label: year });
      return true;
      // return (<MenuItem key={'year_'+yk} value={typeCast(year)} primary={year} />);
    });
    months = Immutable.fromJS(months);
    years = Immutable.fromJS(years);
    const showDelete =
      valueMonth !== undefined &&
      this.state.valueMonth !== false &&
      valueYear !== undefined &&
      this.state.valueYear !== false;
    return (
      <div>
        <span
          style={{
            display: "inline-block",
            verticalAlign: 'middle',
            width: showDelete ? "calc(100% - 50px)" : "100%",
          }}
          className={customStyles.filterField}
        >
          <Select
            variant={'outlined'}
            label={"Mois"}
            value={valueMonth}
            onChange={this.handleChangeMonth.bind(this)}
            style={{ width: "60%" }}
            options={months}
          />
          <Select
            variant={'outlined'}
            label={"Année"}
            style={{ width: "40%" }}
            value={valueYear}
            onChange={this.handleChangeYear.bind(this)}
            options={years}
          />
        </span>

        <If condition={showDelete}>
          <IconButton
            tooltip={"Supprimer"}
            onClick={this.onClearFilter}
            className={customStyles.filterTrash}
            style={{ verticalAlign: "middle" }}
          >
            <IconDelete style={{ verticalAlign: "middle" }} />
          </IconButton>
        </If>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/DynamicList/DynamicFilterPastPresent.jsx